/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SSOImageRepositoryResponsePaginatedResponse } from "../types/SSOImageRepositoryResponsePaginatedResponse.ts";
import { SSOImageRepositoryResponseSchema } from "./SSOImageRepositoryResponseSchema.ts";

export const SSOImageRepositoryResponsePaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => SSOImageRepositoryResponseSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<SSOImageRepositoryResponsePaginatedResponse>;
